/* ZEUS PREMIUM - extras de la pagina de producto.
   Se apoya en el marcado y los datos que ya expone la seccion zs-producto,
   por lo que no duplica la logica de variantes que ya existe. */
(function () {
  'use strict';

  function init() {
    initZoomHover();
    initEstadoVariante();
  }

  /* Lupa sobre la propia foto al pasar el mouse (escritorio).
     El nivel de zoom se define por CSS (--zs-zoom, editable en el editor). */
  function initZoomHover() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-zs-galeria] [data-zs-media-slide]').forEach(function (slide) {
      var img = slide.querySelector('img.zs-prod-media__visual');
      if (!img) return;
      slide.classList.add('zs-prod-media--zoom');

      slide.addEventListener('mousemove', function (e) {
        var r = slide.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
        var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
        img.style.transformOrigin = x + '% ' + y + '%';
        slide.classList.add('zs-zoom-activo');
      });
      slide.addEventListener('mouseleave', function () {
        slide.classList.remove('zs-zoom-activo');
        img.style.transformOrigin = '';
      });
    });
  }

  /* Estado del stock, monto ahorrado y variante en la barra fija.
     Se recalcula despues de cada cambio de opcion. */
  function initEstadoVariante() {
    var form = document.querySelector('[data-zs-form-producto]');
    var dataEl = document.querySelector('[data-zs-variantes-json]');
    var stockEl = document.querySelector('[data-zs-stock]');
    var ahorroEl = document.querySelector('[data-zs-ahorro]');
    var stickyVar = document.querySelector('[data-zs-sticky-variante]');
    var selects = form ? form.querySelectorAll('[data-zs-opcion]') : [];

    var variantes = [];
    if (dataEl) {
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { variantes = []; }
    }

    function varianteActual() {
      if (!variantes.length || !selects.length) return null;
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      }) || null;
    }

    function money(cents) {
      var precioEl = document.querySelector('[data-zs-precio]');
      var moneda = (precioEl && precioEl.dataset.zsCurrency) || 'ARS';
      try {
        return (cents / 100).toLocaleString('es-AR', {
          style: 'currency',
          currency: moneda,
          maximumFractionDigits: 0
        });
      } catch (e) {
        return '$' + Math.round(cents / 100);
      }
    }

    /* Solo se toca classList: el texto lo sigue escribiendo la seccion. */
    function pintarStock() {
      if (!stockEl) return;
      var texto = (stockEl.textContent || '').toLowerCase();
      stockEl.classList.remove('zs-prod-stock--ok', 'zs-prod-stock--bajo', 'zs-prod-stock--agotado');
      if (texto.indexOf('agotado') !== -1 || texto.indexOf('no disponible') !== -1) {
        stockEl.classList.add('zs-prod-stock--agotado');
      } else if (texto.indexOf('queda') !== -1) {
        stockEl.classList.add('zs-prod-stock--bajo');
      } else if (texto.trim()) {
        stockEl.classList.add('zs-prod-stock--ok');
      }
    }

    function pintarAhorro() {
      if (!ahorroEl) return;
      var v = varianteActual();
      if (!v || !v.compare_at_price || v.compare_at_price <= v.price) {
        ahorroEl.hidden = true;
        return;
      }
      var etiqueta = ahorroEl.dataset.zsAhorroTexto || 'Ahorras';
      ahorroEl.textContent = etiqueta + ' ' + money(v.compare_at_price - v.price);
      ahorroEl.hidden = false;
    }

    function pintarSticky() {
      if (!stickyVar || !selects.length) return;
      var partes = Array.prototype.map.call(selects, function (s) { return s.value; }).filter(Boolean);
      stickyVar.textContent = partes.join(' · ');
      stickyVar.hidden = !partes.length;
    }

    function refrescar() {
      pintarStock();
      pintarAhorro();
      pintarSticky();
    }

    /* setTimeout 0: deja que la seccion actualice precio/stock primero. */
    Array.prototype.forEach.call(selects, function (s) {
      s.addEventListener('change', function () { window.setTimeout(refrescar, 0); });
    });
    refrescar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
